export const ONBOARDING_STEPS = [
  {
    key: 'identity',
    title: 'Your identity',
    description: 'Display name + headline',
  },
  {
    key: 'subjects',
    title: 'What you teach',
    description: 'Subjects + grade levels',
  },
  {
    key: 'availability',
    title: 'Your availability',
    description: 'Timezone + weekly hours',
  },
  {
    key: 'bio',
    title: 'About you',
    description: 'Bio + demo video',
  },
  {
    key: 'rate',
    title: 'Your rate',
    description: 'Hourly rate (USD)',
  },
  {
    key: 'photo',
    title: 'Profile photo',
    description: 'A friendly face',
  },
  {
    key: 'bank',
    title: 'Payout details',
    description: 'Optional · You can fill this later for receiving payments',
  },
  {
    key: 'review',
    title: 'Review & publish',
    description: 'Submit for approval',
  },
] as const;

export type OnboardingStepKey = (typeof ONBOARDING_STEPS)[number]['key'];

export const ONBOARDING_STEP_KEYS: ReadonlyArray<OnboardingStepKey> =
  ONBOARDING_STEPS.map((s) => s.key);

export function isOnboardingStepKey(value: string): value is OnboardingStepKey {
  return (ONBOARDING_STEP_KEYS as ReadonlyArray<string>).includes(value);
}

export function nextStepKey(
  completed: ReadonlyArray<string>,
): OnboardingStepKey {
  const set = new Set(completed);
  for (const step of ONBOARDING_STEP_KEYS) {
    if (!set.has(step)) return step;
  }
  return 'review';
}
